import React from 'react';

import {useCharacter} from '../../../character-context';
import {spellManagementTabs, spellPreparations} from '../../../model/spell-list';
import {SpellManagement} from '../../spell-management';
import type {ProcedureModalProps} from './procedure-modal-props';

/** Запоминание заклинания: то же управление заклинаниями, где меняют подготовленные */
export const SpellSwapModal: React.FC<ProcedureModalProps<'spellSwap'>> = ({onClose}) => {
	const {catalog, character} = useCharacter();
	return (
		<SpellManagement
			open
			tabs={spellManagementTabs(spellPreparations(catalog, character), character)}
			onClose={onClose}
		/>
	);
};
